<template>
    <v-flex xs12 class="wrapper">
        <div class="jackpot-wrapper">
            <h2 class="jackpot">Jackpot&nbsp;&nbsp;RM<span id="jp_0">{{ jackpot }}</span></h2>
            <span class="space stars1"></span>
            <span class="space stars2"></span>
            <span class="space stars3"></span>
        </div>
    </v-flex>
</template>
<style scoped>
.jackpot-wrapper {
    background-color: rgba(1, 14, 30, 0.6);
    border-radius: 40% 40% 0 0;
    border-top: .2em solid #988107;
    position:relative;
    display:flex;
    filter: brightness(100%);
    overflow: hidden;
    justify-content: center;
    align-items: center;
}
.jackpot, .jackpot span {
    position: relative;
    z-index: 1;
    background: -webkit-linear-gradient(to bottom, #cfc09f 26%, #cfc09f 27%,#ffecb3 40%,#997401 78%);
    background: linear-gradient(to bottom, #cfc09f 26%, #cfc09f 27%,#ffecb3 40%,#997401 78%);
    background: moz-linear-gradient(to bottom, #997401);
    background: -o-linear-gradient(to bottom, #997401);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    font-family: Arial;
    text-transform: uppercase;
    margin-left: 5px;
    margin-top: -1px;
    margin-bottom: 0px;
    padding-top: 5px;
    padding-bottom: 0px;
}

.jackpot {
  font-size: 14px;
}
@media screen and (min-width: 320px) {
  .jackpot {
    font-size: calc(16px + 6 * ((100vw - 320px) / 680));
  }
}

@media screen and (min-width: 960px) {
  .jackpot {
    font-size: 32px;
  }
}
@media screen and (min-width: 1264px) {
  .jackpot {
    font-size: 36px;
  }
}


.wrapper{
    position: absolute;
    bottom: 0px;
    min-width: 100%;
}

.jackpot::before{
    content: 'Jackpot';
    position: absolute;
    mix-blend-mode: difference;
    filter: blur(3px);
}
.space {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}
.stars1 {
  animation: space 6s ease-in-out infinite;
  background-image:
    radial-gradient(
      1px 1px at 25px 5px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      1px 1px at 50px 25px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      1px 1px at 125px 20px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      1.5px 1.5px at 50px 75px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      2px 2px at 15px 125px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      2.5px 2.5px at 110px 80px,
      white,
      rgba(255, 255, 255, 0)
    );
}
.stars2 {
  animation: space 8s ease-in-out infinite;
  background-image:
    radial-gradient(
      1px 1px at 75px 125px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      1px 1px at 100px 75px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      1.5px 1.5px at 199px 100px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      2px 2px at 20px 50px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      2.5px 2.5px at 100px 5px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      2.5px 2.5px at 5px 5px,
      white,
      rgba(255, 255, 255, 0)
    );
}
.stars3 {
  animation: space 10s ease-in-out infinite;
  background-image:
    radial-gradient(
      1px 1px at 10px 10px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      1px 1px at 150px 150px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      1.5px 1.5px at 60px 170px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      1.5px 1.5px at 175px 180px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      2px 2px at 195px 95px,
      white,
      rgba(255, 255, 255, 0)
    ),
    radial-gradient(
      2.5px 2.5px at 95px 145px,
      white,
      rgba(255, 255, 255, 0)
    );
}
@keyframes space {
  from {
		left: 0;
		top: 0;
	}
	to {
		left: 1000px;
		top: 20px;
	}
}
</style>
<script>
Number.prototype.formatMoney = function (decPlaces, thouSeparator, decSeparator) {
    var n = this,
        decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSeparator = decSeparator == undefined ? "." : decSeparator,
        thouSeparator = thouSeparator == undefined ? "," : thouSeparator,
        sign = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(decPlaces)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return sign + (j ? i.substr(0, j) + thouSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSeparator) + (decPlaces ? decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : "");
};
export default {
    data() {
        return {
            v : new Array(),
            vDisp : new Array(),
            jpCount : 0,
            jackpotTimer: null,
            secondToReload : 1200,
            msecToBlink : 300,
            msecLoaded : 0,
            jackpot: 0
        }
    },
    computed: {
    },
    mounted: function() {
        this.getJackpotValues("10000000.00;20000000.00;", 2);
    },
    methods: {
        increaseJackpot: function() {
            for (let i = 0; i < this.jpCount; i++) {
                if (isNaN(this.vDisp[i])) {

                }
                else {
                    this.vDisp[i] += 0.01;
                }

                this.displayJackpotValues("jp_" + i, this.vDisp[i]);
            }
        },
        getJackpotValues: function(myValues, jpCountValue) {
            this.jpCount = jpCountValue;

            let d = new Date();
            let year = d.getFullYear().toString().length == 1 ? "0" + d.getFullYear().toString() : d.getFullYear().toString();
            let month = d.getMonth().toString().length == 1 ? "0" + d.getMonth().toString() : d.getMonth().toString();
            let date = d.getDate().toString().length == 1 ? "0" + d.getDate().toString() : d.getDate().toString();
            let hour = d.getHours().toString().length == 1 ? "0" + d.getHours().toString() : d.getHours().toString();
            let min = d.getMinutes().toString().length == 1 ? "0" + d.getMinutes().toString() : d.getMinutes().toString();
            let dateOffset = month + date + hour + min;

            for (let i = 0; i < this.jpCount; i++) {
                if (isNaN(myValues.split(";")[i])) {
                    this.vDisp[i] = myValues.split(";")[i];
                }
                else {
                    this.v[i] = parseInt(myValues.split(";")[i]) + parseInt(dateOffset);
                    this.vDisp[i] = this.v[i];
                }
            }

            if (this.msecLoaded == 0) this.jackpotTimer = window.setTimeout(this.increaseJackpot, this.msecToBlink);
        },
        displayJackpotValues: function(myID, myVal) {

            this.msecLoaded += this.msecToBlink

            if (isNaN(myVal)) {
                this.jackpot = myVal;
            }
            else {
                this.jackpot = parseFloat(myVal).formatMoney(2, ',', '.');
            }

            if ((this.secondToReload * 1000) <= this.msecLoaded) {
                this.msecLoaded = 1;
                window.clearTimeout(this.jackpotTimer);
                //loadJackpot();
                this.jackpotTimer = window.setTimeout(this.increaseJackpot, this.msecToBlink);
            }
            else {
                window.clearTimeout(this.jackpotTimer);
                this.jackpotTimer = window.setTimeout(this.increaseJackpot, this.msecToBlink);
            }
        }


    }
}
</script>
